/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { getCurrentInstance } from '@vue/composition-api';
import isArray from 'lodash/isArray';

function useChildComponentSlots() {
  var instance = getCurrentInstance();
  return function (childComponentName, slots) {
    var _slots, _slots$default;
    if (!slots) {
      var _instance$setupContex;
      slots = (_instance$setupContex = instance.setupContext) === null || _instance$setupContex === void 0 ? void 0 : _instance$setupContex.slots;
    }
    var content = ((_slots = slots) === null || _slots === void 0 || (_slots$default = _slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(_slots)) || [];
    var childList = [];
    var getChildren = function getChildren(content2) {
      if (!isArray(content2)) return;
      content2.forEach(function (item) {
        if (item.children && isArray(item.children)) {
          getChildren(item.children);
        } else {
          childList.push(item);
        }
      });
      return childList;
    };
    return getChildren(content).filter(function (item) {
      var _item$tag;
      return (_item$tag = item.tag) === null || _item$tag === void 0 ? void 0 : _item$tag.endsWith(childComponentName);
    });
  };
}

export { useChildComponentSlots as default, useChildComponentSlots };
//# sourceMappingURL=slots.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/hooks/slots.js
// module id = null
// module chunks = 